"use client"

import { useEffect, useRef, useState } from "react"
import { FaEnvelope, FaWhatsapp, FaMapMarkerAlt } from "react-icons/fa";
import summaryApi from "../common/index";
import { toast } from "react-hot-toast";




export default function ContactUs() {
  const canvasRef = useRef(null)
  const [isVisible, setIsVisible] = useState(false)
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const particlesRef = useRef([])
  const animationIdRef = useRef(null)

  // Canvas Animation for Floating Particles
  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return

    const ctx = canvas.getContext("2d")
    if (!ctx) return

    const resizeCanvas = () => {
      canvas.width = window.innerWidth
      canvas.height = window.innerHeight
    }

    resizeCanvas()
    window.addEventListener("resize", resizeCanvas)

    // Initialize floating particles
    const initParticles = () => {
      particlesRef.current = Array.from({ length: 20 }, () => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        size: Math.random() * 6 + 2,
        vx: (Math.random() - 0.5) * 0.3,
        vy: (Math.random() - 0.5) * 0.3,
        opacity: Math.random() * 0.25 + 0.05,
        rotation: Math.random() * Math.PI * 2,
        rotationSpeed: (Math.random() - 0.5) * 0.015,
        pulse: Math.random() * 0.5,
      }))
    }

    initParticles()

    const animate = () => {
      // Clear with semi-transparent overlay for trail effect
      ctx.fillStyle = "rgba(245, 230, 211, 0.015)"
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      particlesRef.current.forEach((particle) => {
        // Update position
        particle.x += particle.vx
        particle.y += particle.vy
        particle.rotation += particle.rotationSpeed
        particle.pulse = (particle.pulse + 0.02) % (Math.PI * 2)

        // Bounce effect
        if (particle.x < 0 || particle.x > canvas.width) particle.vx *= -1
        if (particle.y < 0 || particle.y > canvas.height) particle.vy *= -1

        particle.x = Math.max(0, Math.min(canvas.width, particle.x))
        particle.y = Math.max(0, Math.min(canvas.height, particle.y))

        // Draw particle with pulsing effect
        ctx.save()
        const pulseAmount = Math.sin(particle.pulse) * 0.3 + 0.7
        ctx.globalAlpha = particle.opacity * pulseAmount
        ctx.translate(particle.x, particle.y)
        ctx.rotate(particle.rotation)

        // Create gradient
        const gradient = ctx.createRadialGradient(0, 0, 0, 0, 0, particle.size)
        gradient.addColorStop(0, "#D4AF37")
        gradient.addColorStop(0.6, "#8B7500")
        gradient.addColorStop(1, "#654321")

        ctx.fillStyle = gradient
        ctx.beginPath()
        ctx.arc(0, 0, particle.size, 0, Math.PI * 2)
        ctx.fill()

        ctx.restore()
      })

      animationIdRef.current = requestAnimationFrame(animate)
    }

    animate()

    return () => {
      window.removeEventListener("resize", resizeCanvas)
      if (animationIdRef.current) {
        cancelAnimationFrame(animationIdRef.current)
      }
    }
  }, [])

  // Intersection Observer for scroll animations
  useEffect(() => {
    setIsVisible(true)

    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px",
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-in")
        }
      })
    }, observerOptions)

    document.querySelectorAll("[data-animate]").forEach((el) => {
      observer.observe(el)
    })

    return () => observer.disconnect()
  }, [])

  // Form submission
const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  try {
    const res = await fetch(summaryApi.sendEmail.url, {
      method: summaryApi.sendEmail.method,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const data = await res.json();

    if (data.success) {
      toast.success("Your message has been sent successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
    } else {
      toast.error(data.error || "Something went wrong. Please try again.");
    }
  } catch (error) {
    console.error("Error sending email:", error);
    toast.error("Error sending message! Please try again.");
  }

  setIsSubmitting(false);
};


  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F5E6D3] via-[#FAF3E0] to-[#F0E5D8] overflow-hidden relative">
      <canvas ref={canvasRef} className="fixed top-0 left-0 w-full h-full pointer-events-none opacity-50 z-0" />

      {/* Background gradient overlay */}
      <div className="fixed inset-0 bg-gradient-to-br from-transparent via-[#FAF3E0]/30 to-[#E8D4B8]/20 pointer-events-none z-0" />

      {/* Main content */}
      <div className="relative z-10">
        {/* Hero Section */}
        <section className="min-h-screen flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 py-20">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <div
              className="space-y-6"
              style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? "translateY(0)" : "translateY(20px)",
                transition: "all 1s ease-out",
              }}
            >
             <div className="inline-block text-center">
  <span
    className="text-5xl sm:text-6xl lg:text-7xl font-serif font-light tracking-tight 
               bg-gradient-to-r from-[#8B4513] via-[#D4AF37] to-[#654321] 
               bg-clip-text text-transparent drop-shadow-md"
    style={{
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundImage: "linear-gradient(90deg, #8B4513 0%, #D4AF37 50%, #654321 100%)",
    }}
  >
    Get In Touch
  </span>
</div>


              <p className="text-xl sm:text-2xl text-[#654321] font-light leading-relaxed max-w-2xl mx-auto">
                Reach out to us for wholesale inquiries, retail purchases, or any questions about our premium Saudi
                dates
              </p>

              <div className="flex flex-wrap justify-center gap-4 pt-6">
                <span className="px-6 py-2 bg-white/40 backdrop-blur-sm rounded-full text-[#654321] font-medium border border-[#D4AF37]/20">
                  Fast Response
                </span>
                <span className="px-6 py-2 bg-white/40 backdrop-blur-sm rounded-full text-[#654321] font-medium border border-[#D4AF37]/20">
                  24/7 Available
                </span>
                <span className="px-6 py-2 bg-white/40 backdrop-blur-sm rounded-full text-[#654321] font-medium border border-[#D4AF37]/20">
                  Expert Support
                </span>
              </div>
            </div>

            <div className="pt-12 animate-bounce">
              <svg className="w-6 h-6 mx-auto text-[#8B4513]/50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </div>
          </div>
        </section>

{/* Contact Information Cards */}
<section className="py-24 px-4 sm:px-6 lg:px-8 bg-white/20 backdrop-blur-md">
  <div className="max-w-6xl mx-auto">
    <h2 className="text-4xl sm:text-5xl font-serif font-light text-[#654321] text-center mb-16">
      Multiple Ways to Reach Us
    </h2>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
      {[
        {
          icon: <FaEnvelope />,
          title: "Email",
          content: "imranandsonstraders@gmail.com",
          description: "Send us an email for detailed inquiries, wholesale requests, or product information.",
          action: "mailto:imranandsonstraders@gmail.com",
        },
        {
          icon: <FaWhatsapp />,
          title: "WhatsApp / Call",
          content: "+44 7956 575153",
          description: "Reach us directly via WhatsApp or phone for quick responses.",
          action: "https://wa.me/447956575153",
        },
        {
          icon: <FaMapMarkerAlt />,
          title: "Nationwide Delivery",
          content: "All of Saudi Arabia 🇸🇦",
          description: "We deliver premium dates to customers across the entire nation with careful tracking.",
          action: "#",
        },
      ].map((card, idx) => (
        <a
          key={idx}
          href={card.action}
          data-animate
          target={card.action.startsWith("http") ? "_blank" : "_self"}
          rel={card.action.startsWith("http") ? "noopener noreferrer" : ""}
          className="group opacity-0 p-8 rounded-2xl bg-gradient-to-br from-white/50 to-white/20 backdrop-blur-sm border border-[#D4AF37]/30 hover:border-[#D4AF37]/60 transition-all duration-500 hover:shadow-xl hover:-translate-y-2 cursor-pointer"
          style={{
            animation: isVisible ? `slideInUp 0.8s ease-out ${0.2 + idx * 0.1}s forwards` : "none",
          }}
        >
          <div className="text-5xl mb-4 transform group-hover:scale-110 transition-transform">{card.icon}</div>
          <h3 className="text-2xl font-serif font-light text-[#654321] mb-2">{card.title}</h3>
          <p className="text-xl font-medium text-[#8B4513] mb-3">{card.content}</p>
          <p className="text-[#654321]/70 leading-relaxed">{card.description}</p>
        </a>
      ))}
    </div>
  </div>
</section>

        {/* Contact Form Section */}
        <section className="py-24 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="mb-16 text-center">
              <h2 className="text-4xl sm:text-5xl font-serif font-light text-[#654321] mb-6">Send Us a Message</h2>
              <p className="text-lg text-[#654321]/70">
                Fill out the form below and we'll get back to you as soon as possible
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <div
                data-animate
                className="opacity-0 p-8 sm:p-12 rounded-3xl bg-gradient-to-br from-white/60 to-white/30 backdrop-blur-md border border-[#D4AF37]/40 shadow-2xl"
                style={{
                  animation: isVisible ? `slideInUp 0.8s ease-out 0.3s forwards` : "none",
                }}
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  {/* Name Field */}
                  <div>
                    <label className="block text-[#654321] font-medium mb-2">Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Your name"
                      className="w-full px-4 py-3 bg-white/60 border border-[#D4AF37]/30 rounded-lg text-[#654321] placeholder-[#654321]/40 focus:outline-none focus:border-[#D4AF37]/60 focus:ring-2 focus:ring-[#D4AF37]/20 transition-all"
                    />
                  </div>

                  {/* Email Field */}
                  <div>
                    <label className="block text-[#654321] font-medium mb-2">Email Address *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="your@email.com"
                      className="w-full px-4 py-3 bg-white/60 border border-[#D4AF37]/30 rounded-lg text-[#654321] placeholder-[#654321]/40 focus:outline-none focus:border-[#D4AF37]/60 focus:ring-2 focus:ring-[#D4AF37]/20 transition-all"
                    />
                  </div>

                  {/* Phone Field */}
                  <div>
                    <label className="block text-[#654321] font-medium mb-2">Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+966..."
                      className="w-full px-4 py-3 bg-white/60 border border-[#D4AF37]/30 rounded-lg text-[#654321] placeholder-[#654321]/40 focus:outline-none focus:border-[#D4AF37]/60 focus:ring-2 focus:ring-[#D4AF37]/20 transition-all"
                    />
                  </div>

                  {/* Subject Type Field */}
                  {/* <div>
                    <label className="block text-[#654321] font-medium mb-2">Inquiry Type *</label>
                    <select
                      name="type"
                      value={formData.type}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-white/60 border border-[#D4AF37]/30 rounded-lg text-[#654321] focus:outline-none focus:border-[#D4AF37]/60 focus:ring-2 focus:ring-[#D4AF37]/20 transition-all appearance-none cursor-pointer"
                    >
                      <option value="retail">Retail Purchase</option>
                      <option value="wholesale">Wholesale Inquiry</option>
                      <option value="export">Export Information</option>
                      <option value="partnership">Business Partnership</option>
                      <option value="general">General Question</option>
                    </select>
                  </div> */}



                </div>

                {/* Subject Line */}
                <div className="mb-6">
                  <label className="block text-[#654321] font-medium mb-2">Subject *</label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="What is this about?"
                    className="w-full px-4 py-3 bg-white/60 border border-[#D4AF37]/30 rounded-lg text-[#654321] placeholder-[#654321]/40 focus:outline-none focus:border-[#D4AF37]/60 focus:ring-2 focus:ring-[#D4AF37]/20 transition-all"
                  />
                </div>

                {/* Message Field */}
                <div className="mb-8">
                  <label className="block text-[#654321] font-medium mb-2">Message *</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Tell us more about your inquiry..."
                    rows="6"
                    className="w-full px-4 py-3 bg-white/60 border border-[#D4AF37]/30 rounded-lg text-[#654321] placeholder-[#654321]/40 focus:outline-none focus:border-[#D4AF37]/60 focus:ring-2 focus:ring-[#D4AF37]/20 transition-all resize-none"
                  />
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full md:w-auto px-10 py-4 bg-gradient-to-r from-[#8B4513] to-[#654321] text-white font-serif font-medium rounded-lg hover:shadow-lg hover:-translate-y-1 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 text-lg"
                >
                  {isSubmitting ? "Sending..." : "Send Message"}
                </button>

                <p className="text-sm text-[#654321]/60 mt-4">* Required fields</p>
              </div>
            </form>
          </div>
        </section>

<section className="py-24 px-4 sm:px-6 lg:px-8">
  <div className="max-w-4xl mx-auto">
    {/* Section Heading */}
    <h2
      className="text-4xl sm:text-5xl font-serif font-light text-center mb-16 
                 bg-gradient-to-r from-[#8B4513] via-[#D4AF37] to-[#654321] 
                 bg-clip-text text-transparent drop-shadow-md"
      style={{
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundImage: "linear-gradient(90deg, #8B4513 0%, #D4AF37 50%, #654321 100%)",
      }}
    >
      Frequently Asked Questions
    </h2>

    {/* FAQ Cards */}
    <div className="space-y-6">
      {[
        {
          question: "What is your minimum order for wholesale?",
          answer:
            <>We welcome orders of all sizes. For bulk wholesale inquiries, please contact us directly at <a href="mailto:imranandsonstraders@gmail.com" className="text-[#8B4513] hover:text-[#D4AF37] font-medium">imranandsonstraders@gmail.com</a> to discuss custom packages and competitive pricing tailored to your needs.</>,
        },
        {
          question: "Do you ship internationally?",
          answer:
            "Currently, we provide nationwide delivery across Saudi Arabia. International export inquiries are welcome—please contact us for details and custom arrangements.",
        },
        {
          question: "How long do dates stay fresh?",
          answer:
            "Our premium dates are carefully packaged to maintain freshness. When stored in a cool, dry place, they remain fresh for several months. For specific storage guidelines, we recommend contacting our support team.",
        },
        {
          question: "What makes your dates special?",
          answer:
            "Our dates are 100% natural, handpicked from heritage farms in Madinah Al Munawwarah, and undergo strict quality control. We use no artificial additives or processing aids, ensuring pure, authentic flavor and nutrition.",
        },
        {
          question: "Can I customize my order?",
          answer:
            "We offer customizable packages for both retail and wholesale customers. Whether you need specific varieties, quantities, or special packaging, our team can work with you to meet your requirements.",
        },
        {
          question: "How quickly can you process orders?",
          answer:
            "We strive for fast turnaround times. Standard orders are typically processed within 2-3 business days. For large wholesale orders, processing time depends on quantity and availability—contact us for specifics.",
        },
      ].map((faq, idx) => (
        <div
          key={idx}
          data-animate
          className="opacity-0 group p-6 sm:p-8 rounded-2xl bg-white/50 backdrop-blur-sm border border-[#D4AF37]/30 hover:border-[#D4AF37]/60 transition-all duration-500 hover:shadow-lg"
          style={{
            animation: isVisible ? `slideInUp 0.8s ease-out ${0.2 + (idx % 3) * 0.1}s forwards` : "none",
          }}
        >
          <h3 className="text-xl font-serif font-light mb-3 flex items-start">
            {/* Q marker with gradient */}
            <span
              className="mr-4 text-2xl bg-gradient-to-r from-[#8B4513] via-[#D4AF37] to-[#654321] bg-clip-text text-transparent"
              style={{
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundImage:
                  "linear-gradient(90deg, #8B4513 0%, #D4AF37 50%, #654321 100%)",
              }}
            >
              Q
            </span>
            <span className="text-[#654321] text-balance">{faq.question}</span>
          </h3>
          <p className="text-[#654321]/80 leading-relaxed ml-8">{faq.answer}</p>
        </div>
      ))}
    </div>
  </div>
</section>



 {/* Direct Contact CTA */}
<section className="py-24 px-4 sm:px-6 lg:px-8">
  <div className="max-w-4xl mx-auto text-center">
    <div
      data-animate
      className="opacity-0 p-12 rounded-3xl bg-gradient-to-br from-white/60 to-white/30 backdrop-blur-md border border-[#D4AF37]/40"
      style={{
        animation: isVisible ? `slideInUp 0.8s ease-out 0.4s forwards` : "none",
      }}
    >
      <h2 className="text-3xl sm:text-4xl font-serif font-light text-[#654321] mb-6">
        Prefer Direct Communication?
      </h2>

      <p className="text-lg text-[#654321]/80 mb-12 leading-relaxed">
        Reach out to us directly via email for personalized support, bulk inquiries, or special requests.
      </p>

      <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
        <a
          href="mailto:imranandsonstraders@gmail.com"
          className="inline-block px-8 py-4 bg-[linear-gradient(90deg,#D4AF37,#F5D76E)] text-[#654321] font-serif font-medium rounded-lg hover:shadow-lg hover:-translate-y-1 transition-all duration-300 text-lg"
        >
          📧 Email Us Now
        </a>

        <button
          onClick={() => {
            document.querySelector("[name='message']").focus();
            window.scrollTo({ top: document.querySelector("form").offsetTop - 100, behavior: "smooth" });
          }}
          className="inline-block px-8 py-4 bg-[linear-gradient(90deg,#F0C75E,#D4AF37)] text-[#654321] font-serif font-medium rounded-lg hover:shadow-lg hover:-translate-y-1 transition-all duration-300 text-lg"
        >
          💬 Use Contact Form
        </button>
      </div>
      <p className="text-[#654321]/60 text-sm">Average response time: Within 24 hours</p>
    </div>
  </div>
</section>


      </div>

      {/* Animations */}
      <style>{`
        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-40px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(40px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px) rotate(0deg);
          }
          50% {
            transform: translateY(-20px) rotate(5deg);
          }
        }

        .animate-bounce {
          animation: bounce 2s infinite;
        }

        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        /* Select styling */
        select {
          background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23654321' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
          background-repeat: no-repeat;
          background-position: right 0.5rem center;
          background-size: 1.5em 1.5em;
          padding-right: 2.5rem;
        }
      `}</style>
    </div>
  )
}
